import React, { Component } from 'react';
import styled from 'styled-components';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom components
import CompanyInterfaceForm, {
    ComponentWrapper,
} from 'containers/CompanyContainer/CompanyInterfaceForm';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';

// Constants
import { constants } from 'constants/index';
import { auth } from 'firebase';

const FormWrapper = styled.form`
    width: 93vw;
    max-width: 1200px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 150px;
`;

const InstructionsWrapper = styled.div`
    font: 24px Open Sans, Helvetica, sans-serif;
    color: ${constants.color.grey34};
`;

class ResetPasswordContainer extends Component {
    state = {
        password: '',
        confirmedPassword: '',
        passwordsMatch: false,
        passwordIsValid: false,
        passwordStrength: null,
    };

    checkPassStrength = pass => {
        const score = this.scorePassword(pass);
        if (score > 80) return 'strong';
        if (score > 60) return 'good';
        if (score >= 30) return 'weak';
        return 'weak';
    };

    scorePassword = pass => {
        let score = 0;
        if (!pass) return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i = 0; i < pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        };

        var variationCount = 0;
        for (var check in variations) {
            if (check) variationCount += variations[check] == true ? 1 : 0; // Are you using dynamic typing coercion on purpose, if not, should be ===
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    };

    validatePassword = event => {
        const { confirmedPassword } = this.state;
        const password = event.target.value;
        let passwordIsValid;
        let passwordValidationError = null;
        let passwordStrength = this.checkPassStrength(password);
        passwordStrength === 'weak'
            ? (passwordIsValid = false)
            : (passwordIsValid = true);
        passwordIsValid ? (passwordStrength = null) : null;
        this.setState({ passwordIsValid, passwordStrength, password });
    };

    confirmPassword = event => {
        const { password } = this.state;
        const confirmedPassword = event.target.value;
        let passwordsMatch;
        password === confirmedPassword
            ? (passwordsMatch = true)
            : (passwordsMatch = false);
        this.setState({ passwordsMatch, confirmedPassword });
    };

    submitPasswordChange = event => {
        event.preventDefault();
        const { setNewPassword } = this.props;
        this.props
            .setNewPassword(this.state.password)
            .then(passwordSetSuccessfully => {
                if (passwordSetSuccessfully) {
                    this.props.getClientData(this.props.userId);
                    console.log('SHOULD RESET TO HOME');
                    // redirect to home page
                }
            });
    };

    render() {
        const {
            password,
            confirmedPassword,
            passwordsMatch,
            passwordIsValid,
            passwordStrength,
        } = this.state;
        const getButtonStyles = isPasswordValid =>
            !isPasswordValid
                ? {
                      background: constants.color.grey5,
                      color: constants.color.grey34,
                  }
                : null;
        const buttonStyles = getButtonStyles(passwordIsValid && passwordsMatch);

        const { userData } = this.props;
        const isPendingUser = userData.isPendingActivation;
        if (!isPendingUser) {
            return <Redirect to={`/`} />;
        }

        return (
            <ComponentWrapper>
                <FormWrapper onSubmit={this.submitPasswordChange}>
                    <InstructionsWrapper>
                        Please create your password.
                    </InstructionsWrapper>
                    <FormTextField
                        label="Password"
                        name="password"
                        onChange={this.validatePassword}
                        value={password}
                        onfocusout={e => this.validatePassword(e)}
                        errorMessage={
                            passwordStrength
                                ? `${passwordStrength} password`
                                : null
                        }
                        required={true}
                        inputProps={{
                            type: 'password',
                        }}
                    />
                    <FormTextField
                        label="Confirm"
                        name="confirmedPassword"
                        onChange={this.confirmPassword}
                        value={confirmedPassword}
                        errorMessage={
                            !passwordsMatch
                                ? 'Must match the above password'
                                : null
                        }
                        onfocusout={e => this.confirmPassword(e)}
                        required={true}
                        inputProps={{
                            type: 'password',
                        }}
                    />
                    <CompanyPageButton
                        test-label="saveButton"
                        type={'dark'}
                        size={'small'}
                        children={'Create password'}
                        disabled={!(passwordsMatch && passwordIsValid)}
                        buttonStyle={buttonStyles}
                    />
                </FormWrapper>
            </ComponentWrapper>
        );
    }
}

const mapStateToProps = ({ client, auth }) => ({
    userData: client.clientData,
    userId: auth && auth.authData && auth.authData.uid,
});

export default connect(
    mapStateToProps,
    actions,
)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/js/containers/AccountActivation/ResetPasswordContainer.jsx